import { XTypography, XUpdatableInput } from "~/jsx/components/design";
import { getGravatarUrl } from "~/jsx/hook";
import { Spacing } from "~/jsx/theme";
import { LobbyUser } from "~/utils";

const size = 24;

export const XLobbyUser = ({
  user,
  onUpdate,
}: {
  user: LobbyUser;
  onUpdate?: (newName: string) => void;
}) => {
  return (
    <XTypography>
      <img
        src={getGravatarUrl(user, size)}
        alt={`avatar of ${user.name}`}
        style={{
          verticalAlign: "middle",
          marginRight: Spacing.px8,
          width: size,
          maxWidth: size,
          height: size,
          maxHeight: size,
          pointerEvents: "none",
        }}
      />
      {onUpdate ? (
        <div style={{ display: "inline-block" }}>
          <XUpdatableInput value={user.name} onChange={onUpdate} />
        </div>
      ) : (
        <span>{user.name}</span>
      )}
    </XTypography>
  );
};
